const LOCAL_STORAGE = {
  USER_ADDED_TO_SERVER: 'user_added_to_server',
  PRIVACY_POLICY_ACCEPT: 'privacy_policy_accept',
  LOG_IN_TIME: 'log_in_time',
  AUTH_TOKEN: 'auth_token',
  USER: 'user',
  STATIC_VALUE: {
    YES: 'yes',
    NO: 'no',
  },
};

export default LOCAL_STORAGE;
